import React from 'react';
import '../styles/bottomcontainer.css'; // Make sure to import your CSS file
export default function SkillsContent() {



  return (
    <>
    <p> Computer Languages: Python, JavaScript, C++, HTML, CSS    </p>
    <p>Linux operating system, Networking, AWS Cloud computing, React, Figma</p>
    <p>Data Structures and Algorithms</p>
    <p>Data analysis sing python libraries</p>
    </>
  );
}
